import React from 'react'
import { NavLink as RRLink } from 'react-router-dom'
import styled from 'styled-components'


const LinkStyled = styled(RRLink)`
  text-decoration: none;
  color: inherit;
`

export const LinkComponent = ({
  relative, to, staticContext, ...rest
}) => {
  let finalTo = to
  if (relative) {
    finalTo = `${to}`
  }

  return <LinkStyled {...rest} to={finalTo} />
}

export const Link = LinkComponent
